import { createFileRoute } from '@tanstack/react-router';

import HomeRedirect from '@/components/home-redirect';

export const Route = createFileRoute('/')({
  component: Index,
});

function Index() {
  return <HomeRedirect />;
}
